import HosesSection from "../../../views/workorder/tabs/machines-parts/sections/HosesSection";
import PartsSection from "../../../views/workorder/tabs/machines-parts/sections/PartsSection";
import { Button, Typography } from "@material-tailwind/react";
import { PlusCircleIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
import { useWorkorderContext } from "../../../context/WorkorderContext";

interface MachineContentProps {
  workorderId: string;
  machineId: string;
  onRemoveHose: (hoseId: string) => Promise<void>;
  onAddPart?: () => void;
  canEdit: boolean;
}

/**
 * Composant pour afficher le contenu principal d'une machine (flexibles et autres pièces)
 * Ce composant est affiché dans le corps de l'accordéon
 */
export default function MachineContent({
  workorderId,
  machineId,
  onRemoveHose,
  onAddPart,
  canEdit,
}: MachineContentProps) {
  const { editingPartId } = useWorkorderContext();

  return (
    <div className="pl-6">
      <div>
        <HosesSection
          workorderId={workorderId}
          machineId={machineId}
          targetType="machine"
          onRemoveHose={onRemoveHose}
          key={`machine-hoses-${machineId}`}
          canEdit={canEdit}
        />
        <div className="flex justify-between items-center mt-4 mb-4">
          <Typography
            variant="h5"
            className="font-medium text-gray-900 uppercase"
          >
            {t("workorder:machines:otherParts")}
          </Typography>
          {onAddPart && (
            <Button
              variant="filled"
              size="md"
              className="flex items-center gap-2 bg-blue-50 shadow-md text-sm text-blue-500 px-3 rounded-lg font-thin normal-case"
              onClick={onAddPart}
              disabled={!canEdit || !!editingPartId}
            >
              <PlusCircleIcon className="h-4 w-4" />
              {t("workorder:addPart")}
            </Button>
          )}
        </div>
        <PartsSection
          workorderId={workorderId}
          machineId={machineId}
          targetType="machine"
          key={`machine-parts-${machineId}`}
          canEdit={canEdit}
        />
      </div>
    </div>
  );
}
